import { Component, OnInit } from '@angular/core';
import { UserService } from 'src/app/user.service';

@Component({
  selector: 'app-comparison',
  templateUrl: './comparison.component.html',
  styleUrls: ['./comparison.component.scss']
})
export class ComparisonComponent implements OnInit {

  constructor(public user: UserService) { }

  enhanced_statistic: any;
  have_statistic: any;
  enhancer: any;

  ngOnInit() {
    if (localStorage.getItem('current_enhanced_statistic') != undefined){
      this.user.getStatistic(localStorage.getItem('current_enhanced_statistic')).subscribe(statistic =>{
        this.enhanced_statistic = statistic;
      });
    }
    if (localStorage.getItem('current_have_statistic') != undefined){
      this.user.getStatistic(localStorage.getItem('current_have_statistic')).subscribe(statistic =>{
        this.have_statistic = statistic;
      });
    }
    if (localStorage.getItem('current_enhancer') != undefined){
      this.user.getEnhancer(localStorage.getItem('current_enhancer')).subscribe(enhancer=>{
        this.enhancer = enhancer;
      });
    }
  }

}
